<template>
  <div>
    <div
      class="mx-auto flex w-full max-w-content-container flex-col justify-center gap-y-7 px-small pb-20 pt-8 md:items-start xl:pb-36 xl:pl-16 xl:pr-0 xl:pt-10"
    >
      <Breadcrumb :menu="breadcrumbMenu" />
      <div class="flex w-full flex-col gap-y-6">
        <SectionTitle :title="title" authorized :icon="icon" />
        <Hero
          v-if="!isViewMoreActive"
          :loading="loading"
          :market="slug"
          :articles="articles"
          :videos="videos"
          :events="events"
          @play-video="$emit('playVideo')"
        />
        <TheTabsBySlug :tabs="tabs" />
        <div class="lg:min-h-[32rem]">
          <slot />
        </div>
      </div>
    </div>

    <VideoModal
      v-if="vimeoVideo && modalStore.getModal('videoIntro')"
      :vimeo-source="vimeoSource"
      :video-ratio="videoRatio"
      :is-preview="isPreviewVideo"
    />

    <PdfViewerModal :url="pdfUrl" @close="closeViewer" />
  </div>
</template>

<script lang="ts" setup>
import type { TMarketServiceConfig } from '~/src/types/markets'
import { useBreadcrumbStore } from '~/stores/breadcrumb'
import { useModalStore } from '~/stores/modal'

import TheTabsBySlug from '~/components/common/TheTabsBySlug.vue'
import PdfViewerModal from '~/components/critical-insights/PdfViewerModal.vue'
import Hero from '~/components/market-insights/Hero.vue'
import SectionTitle from '~/components/price-assessments/SectionTitle.vue'
import Breadcrumb from '~/components/shared/navigation/Breadcrumb.vue'
import VideoModal from '~/components/video/VideoModal.vue'

const props = defineProps<{
  market: TMarketServiceConfig
  loading: boolean
  articles: any[]
  videos: any[]
  events: any[]
  vimeoSource: any
  videoRatio: any
  vimeoVideo: any
  isPreviewVideo
  tabs?: any[]
  categoriesArticles?: any[]
}>()

const breadcrumbStore = useBreadcrumbStore()
const { items: breadcrumbMenu } = storeToRefs(breadcrumbStore)
const modalStore = useModalStore()
const { modalParams } = storeToRefs(modalStore)

const isViewMoreActive = useState<boolean>('isViewMoreActive')

const pdfUrl = computed(() => modalParams.value?.pdfUrl)
const icon = computed(() => props.market.iconColor)
const title = computed(() => `${props.market.name} Market Insights`)
const slug = computed(() => props.market.slug)

const closeViewer = () => {
  modalStore.setModalParams({ pdfUrl: '' })
}
</script>
